import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-edit-in-place',
  templateUrl: './EditInPlace.component.html',
  styleUrls: ['./EditInPlace.component.less'],
})
export class EditInPlaceComponent {
  @Input() set data(value: any) {
    if (value != this.oldData) {
      this._data = value;
      this.oldData = value;
      this.changed=true;
    }
    else{
      this.changed=false;
    }
  }
  get data() {
    return this._data;
  }
  changed:boolean;
  @Input() object: any;
  @Input() key: any;
  @Input() editMode: boolean = false;
  @Output() focusOut: EventEmitter<any> = new EventEmitter<any>();
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('editfeild') editFeild: ElementRef;
  oldData: any;
  _data: any;
  constructor() {}

  onFocusOut() {
    this.editMode = false;

    if(this.changed===true){

      this.valueChanged.emit({key:this.key,val:this._data})
    }

    // this.focusOut.emit(this.data);
  }
  onFocusOut1(event: any) {
    if (event.keyCode == 13) {
      this.editMode = false;
      if(this.changed===true){

        this.valueChanged.emit({key:this.key,val:this._data})
      }
    }
  }

  onFocus() {
    this.editMode = true;

    setTimeout(() => {
      this.editFeild.nativeElement.focus();
      this.editFeild.nativeElement.click();
    }, 100);
  }
}
